import { PAGES_URL } from 'constants/index';

export const breadcrumbSearchBase = [
  { label: 'Home', link: PAGES_URL.home },
  { label: 'Encontre eventos', link: PAGES_URL.events },
];
